import { useFormik } from 'formik';
import { useState } from 'react';

import AssetsCountryInterface from '@api/requests/assets/interfaces/AssetsCountryInterface.interface';

import { getAssetsCountries } from '@app/redux/assets/assets.selectors';
import { useAppSelector } from '@app/redux/hooks';

import { RegistrationFormProps, RegistrationFormValues } from './interfaces';
import registrationFormValidationScheme from './validationScheme';

const PRIORITY_COUNTRIES_CODES = ['IND', 'USA'];

function useRegistrationForm({ initialValues, onSubmit }: Pick<RegistrationFormProps, 'initialValues' | 'onSubmit'>) {
	const [showPassword, setShowPassword] = useState(false);
	const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);

	const handleShowPassword = () => setShowPassword(!showPassword);
	const handleShowPasswordConfirmation = () => setShowPasswordConfirmation(!showPasswordConfirmation);

	const assetsCountries = useAppSelector(getAssetsCountries);

	const formik = useFormik<RegistrationFormValues>({
		initialValues,
		validationSchema: registrationFormValidationScheme(assetsCountries),
		onSubmit,
	});

	return {
		showPassword,
		showPasswordConfirmation,
		handleShowPassword,
		handleShowPasswordConfirmation,
		formik,
		phoneCodeOptions: [...assetsCountries]
			.reduce(
				(res, curr) => (PRIORITY_COUNTRIES_CODES.includes(curr.code) ? [curr, ...res] : [...res, curr]),
				[] as AssetsCountryInterface[],
			)
			.sort((a, b) =>
				PRIORITY_COUNTRIES_CODES.includes(a.code)
					? PRIORITY_COUNTRIES_CODES.indexOf(a.code) - PRIORITY_COUNTRIES_CODES.indexOf(b.code)
					: 1,
			)
			.map((country, index) => ({
				isPriorityGroup: index === PRIORITY_COUNTRIES_CODES.length - 1,
				dial_code: country.dial_code,
				country_name: country.name,
			})),
	};
}

export default useRegistrationForm;
